<template>
    <!-- 报表管理－考勤人员管理 -->
    <div>
        <content-view v-show="$utils.renderWhen(this, 'employeeManage')">
            <div slot="header">
                <a-form :form="form" layout="inline" class="store-one-form">
                    <a-form-item label="员工姓名">
                        <a-input placeholder="请输入" v-decorator="['name']" @pressEnter="search"></a-input>
                    </a-form-item>
                    <a-form-item label="英文名">
                        <a-input placeholder="请输入" v-decorator="['englishName']" @pressEnter="search"></a-input>
                    </a-form-item>
                    <a-form-item class="wrap-header-button">
                        <a-button class="mr8" type="primary" @click="search">筛选</a-button>
                        <a-button @click="reset">重置</a-button>
                    </a-form-item>
                </a-form>
            </div>
            <a-card :bordered="false">
                <div slot="extra">
                    <a-button v-if="getBtnByAuth('employeeManageGroup')" class="mr8" @click="openGroupModal">查看/修改轮换分组</a-button>
                    <a-button v-if="getBtnByAuth('employeeManageAdd')" type="primary" @click="openAddModal">新增人员</a-button>
                </div>
                <a-table
                    bordered
                    :dataSource="dataSource"
                    :columns="columns"
                    :pagination="pagination"
                    :loading="loading"
                    :rowKey="record => record.id"
                >
                    <template slot="businessTripFrequencyTitle">
                        <span>外出频次</span>
                        <a-tooltip title="考勤为[正常（外出）]的概率，值越大出差概率越大">
                            <a-icon type="question-circle" style="margin-left: 4px; color: rgba(0,0,0,.45); cursor: pointer;" />
                        </a-tooltip>
                    </template>
                    <template slot="outTripFrequencyTitle">
                        <span>异地频次</span>
                        <a-tooltip title="不出现考勤记录的概率，值越大不出现的概率越大">
                            <a-icon type="question-circle" style="margin-left: 4px; color: rgba(0,0,0,.45); cursor: pointer;" />
                        </a-tooltip>
                    </template>
                    <template slot="outTripFrequency" slot-scope="val">{{ val != null ? val + '%' : '--' }}</template>
                    <template slot="empty" slot-scope="val">{{ val || '--' }}</template>
                    <template slot="businessTripFrequency" slot-scope="val">{{ val != null ? val + '%' : '--' }}</template>
                    <span slot="action" slot-scope="text, record">
                        <span v-if="getBtnByAuth('employeeManageUpdate')">
                            <a class="text-primary" @click="openEditModal(record)">编辑</a>
                            <a-divider type="vertical" />
                        </span>
                        <a-popconfirm v-if="getBtnByAuth('employeeManageDel')" title="确认删除该员工吗？" @confirm="deleteEmployee(record)">
                            <a class="text-danger">删除</a>
                        </a-popconfirm>
                    </span>
                </a-table>
            </a-card>
        </content-view>

        <!-- 新增/编辑员工弹框 -->
        <a-modal
            :title="modalTitle"
            :visible="formVisible"
            :confirmLoading="formLoading"
            :width="560"
            centered
            @ok="submitForm"
            @cancel="closeFormModal"
        >
            <a-form :form="editForm" :label-col="{ span: 6 }" :wrapper-col="{ span: 16 }">
                <a-form-item label="员工姓名">
                    <a-input
                        placeholder="请输入"
                        v-decorator="['name', { rules: [{ required: true, message: '请输入员工姓名' }] }]"
                    />
                </a-form-item>
                <a-form-item label="英文名">
                    <a-input placeholder="请输入" v-decorator="['englishName']" />
                </a-form-item>
                <a-form-item label="部门">
                    <a-input placeholder="请输入" v-decorator="['department']" />
                </a-form-item>
                <a-form-item label="职位">
                    <a-input placeholder="请输入" v-decorator="['position']" />
                </a-form-item>
                <a-form-item label="异地频次">
                    <a-input-number
                        style="width: 100%"
                        :min="0"
                        :max="100"
                        :formatter="val => val !== '' ? val + '%' : ''"
                        :parser="val => val.replace('%', '')"
                        placeholder="请输入"
                        v-decorator="['outTripFrequency']"
                    />
                </a-form-item>
                <a-form-item label="外出频次">
                    <a-input-number
                        style="width: 100%"
                        :min="0"
                        :max="100"
                        :formatter="val => val !== '' ? val + '%' : ''"
                        :parser="val => val.replace('%', '')"
                        placeholder="请输入"
                        v-decorator="['businessTripFrequency']"
                    />
                </a-form-item>
            </a-form>
        </a-modal>

        <!-- 查看/修改分组弹框 -->
        <a-modal
            title="查看/修改分组"
            :visible="groupVisible"
            :confirmLoading="groupLoading"
            :width="700"
            centered
            @ok="submitGroup"
            @cancel="groupVisible = false"
        >
            <a-form :label-col="{ span: 4 }" :wrapper-col="{ span: 20 }">
                <a-form-item>
                    <span slot="label">
                        生效日期
                        <a-tooltip title="从生效日期开始计算，A组打卡2周后，切换B组">
                            <a-icon type="question-circle" style="margin-left: 4px; color: rgba(0,0,0,.45); cursor: pointer;" />
                        </a-tooltip>
                    </span>
                    <a-date-picker
                        style="width: 220px"
                        placeholder="请选择生效日期"
                        :value="groupStartDate"
                        @change="(_, dateStr) => groupStartDate = dateStr"
                    />
                </a-form-item>
            </a-form>
            <a-row :gutter="16">
                <a-col :span="12">
                    <div class="group-panel">
                        <div class="group-panel-title">A 组</div>
                        <a-select
                            mode="multiple"
                            style="width: 100%"
                            placeholder="请选择 A 组成员"
                            :value="groupA"
                            @change="val => groupA = val"
                            optionFilterProp="children"
                        >
                            <a-select-option
                                v-for="emp in allEmployees"
                                :key="emp.id"
                                :value="emp.id"
                            >{{ emp.name }}{{ emp.englishName ? '(' + emp.englishName + ')' : '' }}</a-select-option>
                        </a-select>
                    </div>
                </a-col>
                <a-col :span="12">
                    <div class="group-panel">
                        <div class="group-panel-title">B 组</div>
                        <a-select
                            mode="multiple"
                            style="width: 100%"
                            placeholder="请选择 B 组成员"
                            :value="groupB"
                            @change="val => groupB = val"
                            optionFilterProp="children"
                        >
                            <a-select-option
                                v-for="emp in allEmployees"
                                :key="emp.id"
                                :value="emp.id"
                            >{{ emp.name }}{{ emp.englishName ? '(' + emp.englishName + ')' : '' }}</a-select-option>
                        </a-select>
                    </div>
                </a-col>
            </a-row>
        </a-modal>
    </div>
</template>

<script type="text/javascript">
import { mapGetters } from 'vuex';

const columns = [
    {
        title: '序号',
        customRender: (text, record, index) => index + 1,
        width: 60,
    },
    {
        title: '员工姓名',
        dataIndex: 'name',
    },
    {
        title: '英文名',
        dataIndex: 'englishName',
        scopedSlots: { customRender: 'empty' },
    },
    {
        title: '部门',
        dataIndex: 'department',
        scopedSlots: { customRender: 'empty' },
    },
    {
        title: '职位',
        dataIndex: 'position',
        scopedSlots: { customRender: 'empty' },
    },
    {
        dataIndex: 'outTripFrequency',
        slots: { title: 'outTripFrequencyTitle' },
        scopedSlots: { customRender: 'outTripFrequency' },
    },
    {
        dataIndex: 'businessTripFrequency',
        slots: { title: 'businessTripFrequencyTitle' },
        scopedSlots: { customRender: 'businessTripFrequency' },
    },
    {
        title: '操作',
        key: 'action',
        scopedSlots: { customRender: 'action' },
        width: 120,
    },
];

export default {
    name: 'employeeManage',
    data() {
        return {
            columns,
            dataSource: [],
            pagination: {
                showSizeChanger: true,
                showQuickJumper: true,
                total: 0,
                pageSize: 20,
                current: 1,
                showTotal() {
                    return `共 ${this.total} 条数据`;
                },
                onShowSizeChange: (current, size) => {
                    this.pagination.current = 1;
                    this.pagination.pageSize = size;
                    this.getList();
                },
                onChange: (page) => {
                    this.pagination.current = page;
                    this.getList();
                },
            },
            loading: false,
            // 新增/编辑弹框
            formVisible: false,
            formLoading: false,
            editingId: null,
            // 分组弹框
            groupVisible: false,
            groupLoading: false,
            allEmployees: [],
            groupA: [],
            groupB: [],
            groupStartDate: '',
        };
    },
    computed: {
        ...mapGetters(['shopId']),
        modalTitle() {
            return this.editingId ? '编辑人员' : '新增人员';
        },
    },
    beforeCreate() {
        this.form = this.$form.createForm(this);
        this.editForm = this.$form.createForm(this);
    },
    methods: {
        search() {
            this.pagination.current = 1;
            this.getList();
        },
        reset() {
            this.form.resetFields();
            this.pagination.current = 1;
            this.getList();
        },
        getList() {
            const { current, pageSize } = this.pagination;
            const { name, englishName } = this.form.getFieldsValue();
            this.loading = true;
            this.$api.employee
                .employeePage({
                    body: {
                        pageNum: current,
                        pageSize,
                        name: name || undefined,
                        englishName: englishName || undefined,
                    },
                })
                .then(res => {
                    this.loading = false;
                    this.dataSource = res.list || [];
                    this.pagination.total = res.total || 0;
                })
                .catch(() => {
                    this.loading = false;
                });
        },
        // ——— 新增/编辑员工 ———
        openAddModal() {
            this.editingId = null;
            this.formVisible = true;
            this.$nextTick(() => {
                this.editForm.resetFields();
            });
        },
        openEditModal(record) {
            this.editingId = record.id;
            this.formVisible = true;
            this.$nextTick(() => {
                this.editForm.setFieldsValue({
                    name: record.name,
                    englishName: record.englishName,
                    department: record.department,
                    position: record.position,
                    outTripFrequency: record.outTripFrequency,
                    businessTripFrequency: record.businessTripFrequency,
                });
            });
        },
        closeFormModal() {
            this.formVisible = false;
            this.editForm.resetFields();
        },
        submitForm() {
            this.editForm.validateFields((err, values) => {
                if (err) return;
                const params = { ...values };
                if (this.editingId) {
                    params.id = this.editingId;
                }
                this.formLoading = true;
                const apiName = this.editingId ? 'employeeUpdate' : 'employeeAdd';
                this.$api.employee[apiName]({ body: params })
                    .then(() => {
                        this.formLoading = false;
                        this.formVisible = false;
                        this.$message.success(this.editingId ? '编辑成功' : '新增成功');
                        this.getList();
                    })
                    .catch(() => {
                        this.formLoading = false;
                    });
            });
        },
        // ——— 删除员工 ———
        deleteEmployee(record) {
            this.$api.employee
                .employeeDelete({ params: { id: record.id } })
                .then(() => {
                    this.$message.success('删除成功');
                    this.getList();
                });
        },
        // ——— 分组管理 ———
        openGroupModal() {
            this.groupVisible = true;
            this.getAllEmployees();
            this.getGroup();
        },
        getAllEmployees() {
            this.$api.employee
                .employeeList({ body: {} })
                .then(res => {
                    this.allEmployees = res || [];
                });
        },
        getGroup() {
            this.$api.employee.employeeGroupGet({}).then(res => {
                this.groupA = (res.groupA || []).map(e => e.id);
                this.groupB = (res.groupB || []).map(e => e.id);
                this.groupStartDate = res.startDate || '';
            });
        },
        submitGroup() {
            const groupAEmployees = this.allEmployees.filter(e => this.groupA.includes(e.id));
            const groupBEmployees = this.allEmployees.filter(e => this.groupB.includes(e.id));
            this.groupLoading = true;
            this.$api.employee
                .employeeGroupUpdate({
                    body: {
                        groupA: groupAEmployees,
                        groupB: groupBEmployees,
                        startDate: this.groupStartDate || undefined,
                    },
                })
                .then(() => {
                    this.groupLoading = false;
                    this.groupVisible = false;
                    this.$message.success('分组更新成功');
                })
                .catch(() => {
                    this.groupLoading = false;
                });
        },
    },
    mounted() {
        this.getList();
    },
    watch: {
        shopId() {
            this.reset();
        },
    },
};
</script>

<style lang="scss" scoped>
.group-panel {
    border: 1px solid #e8e8e8;
    border-radius: 4px;
    padding: 12px;

    &-title {
        font-size: 14px;
        font-weight: bold;
        color: rgba(0, 0, 0, 0.85);
        margin-bottom: 8px;
    }
}
.text-danger {
    color: #f5222d;
}
</style>
